<template>
    <div class="economy-learning-potential">
        <div class="row">
            <div class="col-lg-6">
                <costprice-per-hour />
            </div>
            <div class="col-lg-6">
                <costs-division />
            </div>
        </div>

        <!--<div class="placeholder">
            <div class="placeholder__heading">
                Nøgletal
            </div>
            <div class="placeholder padding">
                <li>Omsætning og dækningsbidrag for perioden (som graf). Fakturadato på opgaverne skal bruges til filtreringen.</li>
                <li>Timer brugt hos kunderne som graf (ligesom på forsiden)</li>
                <li>Gennemsnitlig DG på opgaver i perioden. Skal lægges ind sammen med grafen for omsætning/dækningsbidrag. Kan nemt udregnes ved at tage de allerede udregninger for omsætning og dækningsbidrag.</li>
                <li>Kostpris pr. time: Totalværdi fra kontiene (lønninger, telefon, biler, arbejdstøj) divideret med antal timer brugt på kundeopgaver i alt for indeværende regnskabsår.</li>
                <li>Vareforbrug i faldende orden: Summering af materialer brugt på opgaver.</li>
                <li>Vareforbrugets andel af de samlede opgaveomkostninger: Opdeling mellem samlede omkostning på hhv. materialer og timer, som tilsammen udgør 100%. Vis evt. som en progress bar, så du ved hvor du skal sætte ind og optimere. Tag de samlede beløb med også og vis dem.</li>
            </div>
        </div>-->
        <!--<div class="row">
            <div class="col-lg-12">
                <div class="placeholder">
                    <graph-card
                        heading="Omsætning og DB for perioden"
                        unit="kr."
                        ylabel="?"
                        height="450"
                        endpoint="economy/graph"
                        :dynamicInterval="true"
                        :series="revenueSeries"
                    >
                    </graph-card>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        Vareforbrug
                    </div>
                    <div class="placeholder">
                        Tabel her
                    </div>
                </div>
            </div>
        </div>-->

    </div>
</template>

<script>

export default {
    data () {
        return {
            revenueSeries: [
                {'name': 'Omsætning', 'type': 'line', 'width': 3},
                {'name': 'Dækningsbidrag', 'type': 'area', 'width': 3}
            ]
        }
    },
    components: {
        'costprice-per-hour': require('../components/costpricePerHour'),
        'costs-division': require('../components/costsDivision')
    }
}
</script>



// WEBPACK FOOTER //
// keyFigures.vue?bbf476c4